import React from "react";
import { useLang } from "@/context/LanguageContext";
import { api } from "@/lib/api";
import { FileText, Download, Pin, Eye } from "lucide-react";
import { formatDate } from "@/lib/dateFormat";

const catLabel = {
  ayush: { en: "AYUSH Dept.", gu: "આયુષ વિભાગ" },
  health: { en: "Health Ministry", gu: "આરોગ્ય મંત્રાલય" },
  gmoaa: { en: "GMOAA", gu: "GMOAA" },
};

export const GRListItem = ({ gr }) => {
  const { lang, tf } = useLang();
  const cat = catLabel[gr.category];
  const abs = (u) => (u ? (u.startsWith("http") ? u : `${process.env.REACT_APP_BACKEND_URL}${u}`) : "");
  const fileUrl = gr.pdf_url || gr.official_link || "";
  const allowDownload = gr.allow_download !== false;
  const view = (e) => { e.preventDefault(); if (fileUrl) window.open(abs(fileUrl), "_blank"); };
  const download = (e) => {
    e.preventDefault();
    if (!fileUrl) return;
    if (gr.id) api.grDownload(gr.id).then((d) => window.open(abs(d.url), "_blank")).catch(() => window.open(abs(fileUrl), "_blank"));
    else window.open(abs(fileUrl), "_blank");
  };
  return (
    <div className="flex items-start gap-3 rounded-xl border border-gmoaa-border-subtle bg-white p-4 transition-all duration-300 hover:border-gmoaa-green/40 hover:shadow-sm">
      <span className="mt-0.5 flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-gmoaa-green-light text-gmoaa-green">
        <FileText size={18} />
      </span>
      <div className="min-w-0 flex-1">
        <div className="flex flex-wrap items-center gap-2">
          {gr.pinned && (
            <span className="flex items-center gap-1 rounded-full bg-gmoaa-red-bg px-2 py-0.5 text-[10px] font-semibold text-gmoaa-red">
              <Pin size={10} /> PINNED
            </span>
          )}
          {gr.department && (
            <span className="rounded-full bg-gmoaa-saffron-light px-2 py-0.5 text-[10px] font-medium text-gmoaa-saffron-hover">
              {gr.department}
            </span>
          )}
          {!gr.department && cat && (
            <span className="rounded-full bg-gmoaa-saffron-light px-2 py-0.5 text-[10px] font-medium text-gmoaa-saffron-hover">
              {cat[lang]}
            </span>
          )}
        </div>
        <p className="mt-1.5 line-clamp-2 font-medium text-gmoaa-text-dark">{tf(gr, "title")}</p>
        <p className="mt-1 text-xs text-gmoaa-text-muted">
          {gr.number} · {formatDate(gr.date)}
        </p>
      </div>
      <div className="flex shrink-0 items-center gap-2">
        <button
          onClick={view} disabled={!fileUrl}
          data-testid={`gr-view-${gr.id}`}
          className={`flex items-center gap-1 rounded-lg border border-gmoaa-border-subtle px-2.5 py-1.5 text-xs font-medium text-gmoaa-green transition-colors hover:bg-gmoaa-green-light ${fileUrl ? "" : "pointer-events-none opacity-40"}`}
          title={fileUrl ? "View" : "No file"}
        >
          <Eye size={14} /> View
        </button>
        {allowDownload ? (
          <button
            onClick={download} disabled={!fileUrl}
            data-testid={`gr-download-${gr.id}`}
            className={`flex items-center gap-1 rounded-lg border border-gmoaa-border-subtle px-2.5 py-1.5 text-xs font-medium text-gmoaa-green transition-colors hover:bg-gmoaa-green-light ${fileUrl ? "" : "pointer-events-none opacity-40"}`}
            title="Download PDF"
          >
            <Download size={14} /> PDF
          </button>
        ) : (
          <span className="rounded-lg bg-gmoaa-border-subtle px-2.5 py-1.5 text-xs font-medium text-gmoaa-text-muted" data-testid={`gr-viewonly-${gr.id}`}>View only</span>
        )}
      </div>
    </div>
  );
};
